import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useNotificationsController } from '@atlassian/notification-common';
import { useNotificationStateFilters } from '../../index';
import { useNotificationGroupStore } from '../../services/use-notification-list-store/hooks/use-notification-groups-store';
export var useNotificationGroupsController = function useNotificationGroupsController(locale) {
  var currentNotificationList = useNotificationGroupStore({
    locale: locale
  });
  var fetchState = currentNotificationList.fetchState,
    fetchData = currentNotificationList.fetchData;
  var _useNotificationState = useNotificationStateFilters(),
    _useNotificationState2 = _slicedToArray(_useNotificationState, 1),
    filters = _useNotificationState2[0];
  useNotificationsController(currentNotificationList, filters);
  return {
    fetchState: fetchState,
    fetchData: fetchData
  };
};